import script from "./PaperDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperDetail.vue?vue&type=script&setup=true&lang=js"

import "./PaperDetail.vue?vue&type=style&index=0&id=3024c9b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3024c9b4"]])

export default __exports__